import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_SDG',
  name: 'Workspace Project SDG',
  type: 'PROJECT',
  description: '',
  modules: [],
  actions: ['READ', 'CREATE', 'DESTROY'],
}

export default scope
